var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgMapIcon = function SvgMapIcon(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "M6.003 9.857c0-3.224 2.675-5.856 5.997-5.856s5.997 2.632 5.997 5.856c0 .639-.258 1.486-.717 2.462-.453.965-1.076 2.004-1.749 3.013-1.336 2.001-2.842 3.839-3.53 4.654-.69-.815-2.196-2.653-3.532-4.654-.673-1.009-1.296-2.048-1.749-3.013-.458-.976-.717-1.823-.717-2.462M12 3.001C8.146 3 5.003 6.06 5.003 9.857c0 .864.336 1.873.812 2.888.482 1.026 1.135 2.112 1.822 3.142 1.377 2.062 2.923 3.945 3.615 4.762a.976.976 0 0 0 1.497 0c.691-.817 2.237-2.7 3.614-4.762.688-1.03 1.34-2.116 1.822-3.142.476-1.015.812-2.024.812-2.888 0-3.797-3.143-6.856-6.997-6.856M12 11a1.5 1.5 0 1 0 0-3 1.5 1.5 0 0 0 0 3",
    clipRule: "evenodd"
  })));
};
export default SvgMapIcon;